import Vue from 'vue';
import Vuetify from 'vuetify/lib';


Vue.use(Vuetify); //register "Vuetify" in vue.js

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#F3F5F1', // #snow
        secondary: '#9EC0C4', // #shaded light blue
        third: '#479F7E', // #pinetree light green
        fourth: '#A78964', // #Cocoa
        fifth: '#2C2725', // #Earth brown
      },
    },
  },
});
